import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_active_client.svg'
import _imports_1 from '@/app/ui/assets/svg/x-gray.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_close.svg'
import _imports_3 from '@/app/ui/assets/svg/ill_spot_search.svg'


const _hoisted_1 = { class: "bg-white rounded-lg p-3 flex flex-col gap-3 text-gray-lp-300 border border-gray-lp-1400 mb-2" }
const _hoisted_2 = { class: "flex flex-row items-center gap-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "text-sm font-semibold" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row gap-2 items-center text-sm font-medium text-gray-lp-300",
  style: {"height":"21px"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "delete"
}, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  role: "dialog",
  class: "client-filter-modal",
  name: "p-dialog",
  appear: ""
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "client-filter-modal-overlay" }, null, -1)
const _hoisted_10 = {
  class: "flex flex-col gap-3 p-4 rounded-md bg-white",
  style: {"width":"1030px","max-height":"436px"}
}
const _hoisted_11 = { class: "flex flex-row items-center justify-between" }
const _hoisted_12 = { class: "text-gray-lp-300 text-xl font-semibold" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "close"
}, null, -1)
const _hoisted_14 = { class: "client-filter-table" }
const _hoisted_15 = { style: {"min-width":"220px"} }
const _hoisted_16 = { style: {"min-width":"120px"} }
const _hoisted_17 = { style: {"min-width":"160px"} }
const _hoisted_18 = { style: {"min-width":"180px"} }
const _hoisted_19 = { style: {"min-width":"190px"} }
const _hoisted_20 = { style: {"min-width":"128px"} }
const _hoisted_21 = {
  colspan: 6,
  class: "p-0"
}
const _hoisted_22 = { class: "flex w-full cursor-pointer" }
const _hoisted_23 = { class: "grid grid-cols-6 gap-4 w-full p-2" }
const _hoisted_24 = {
  key: 1,
  class: "w-full flex flex-col gap-4"
}
const _hoisted_25 = {
  key: 2,
  class: "flex flex-col gap-6 justify-center items-center pb-7"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  style: {"width":"224px","height":"190px"},
  src: _imports_3,
  alt: "search"
}, null, -1)
const _hoisted_27 = { class: "flex flex-col gap-2 justify-center items-center" }
const _hoisted_28 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_29 = { class: "text-sm text-gray-lp-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Filter = _resolveComponent("Filter")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("bookingV3.filterClient.title")), 1)
      ]),
      _createVNode(_component_Filter, {
        ref: "filterClient",
        showButtonOpenList: true,
        originValue: _ctx.originValue,
        "onUpdate:originValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.originValue = $event)),
        clientValue: _ctx.clientValue,
        "onUpdate:clientValue": [
          _cache[2] || (_cache[2] = ($event: any) => (_ctx.clientValue = $event)),
          _ctx.onUpdateClient
        ],
        clientSearchValue: _ctx.clientSearchValue,
        "onUpdate:clientSearchValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.clientSearchValue = $event)),
        clientLoading: _ctx.clientLoading,
        "onUpdate:clientLoading": _cache[4] || (_cache[4] = ($event: any) => (_ctx.clientLoading = $event)),
        originLoading: _ctx.originLoading,
        "onUpdate:originLoading": _cache[5] || (_cache[5] = ($event: any) => (_ctx.originLoading = $event)),
        deliveryServiceValues: _ctx.deliveryServiceValues,
        "onUpdate:deliveryServiceValues": _cache[6] || (_cache[6] = ($event: any) => (_ctx.deliveryServiceValues = $event)),
        cityOptions: _ctx.cityOptions,
        clientOptions: _ctx.clientOptions,
        deliveryServiceOptions: _ctx.deliveryServiceOptions,
        error: _ctx.error,
        clientIndex: _ctx.clientIndex,
        currentIndex: _ctx.currentIndex,
        onOpenList: _ctx.showClientListModal,
        onFetchOrigins: _ctx.fetchOrigins,
        onFetchClients: _ctx.fetchClients,
        onDeleteOriginValue: _ctx.deleteOriginValue,
        onDeleteDeliveryService: _ctx.deleteDeliveryService,
        onResetFilter: _ctx.resetFilter,
        isDisabled: _ctx.isDisabled,
        filterValues: _ctx.filterValues
      }, null, 8, ["originValue", "clientValue", "clientSearchValue", "clientLoading", "originLoading", "deliveryServiceValues", "cityOptions", "clientOptions", "deliveryServiceOptions", "error", "clientIndex", "currentIndex", "onUpdate:clientValue", "onOpenList", "onFetchOrigins", "onFetchClients", "onDeleteOriginValue", "onDeleteDeliveryService", "onResetFilter", "isDisabled", "filterValues"]),
      (_ctx.showButtonResetFilter)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterValues, (filter) => {
              return (_openBlock(), _createBlock("div", {
                key: filter.name,
                class: "flex flex-row items-center gap-2 rounded bg-gray-lp-200 px-2"
              }, [
                _createTextVNode(_toDisplayString(filter.label) + " ", 1),
                _createVNode("button", {
                  onClick: ($event: any) => (_ctx.deleteFilter(filter))
                }, [
                  _hoisted_6
                ], 8, ["onClick"])
              ]))
            }), 128)),
            _createVNode("button", {
              class: "text-red-lp-100",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
            }, " Reset ")
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#app > div:nth-child(1)" }, [
      (_ctx.openClientModal)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_Transition, {
                name: "p-dialog",
                class: "client-filter-modal-content",
                appear: "",
                onEnter: _ctx.onModalEnter
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode("h1", _hoisted_12, _toDisplayString(_ctx.$t("bookingV3.filterClient.list.title")), 1),
                      _createVNode("button", {
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onCloseModal && _ctx.onCloseModal(...args)))
                      }, [
                        _hoisted_13
                      ])
                    ]),
                    _createVNode(_component_Filter, {
                      originValue: _ctx.originValue,
                      "onUpdate:originValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.originValue = $event)),
                      clientValue: _ctx.clientValue,
                      "onUpdate:clientValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.clientValue = $event)),
                      clientSearchValue: _ctx.clientSearchValue,
                      "onUpdate:clientSearchValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.clientSearchValue = $event)),
                      clientLoading: _ctx.clientLoading,
                      "onUpdate:clientLoading": _cache[12] || (_cache[12] = ($event: any) => (_ctx.clientLoading = $event)),
                      originLoading: _ctx.originLoading,
                      "onUpdate:originLoading": _cache[13] || (_cache[13] = ($event: any) => (_ctx.originLoading = $event)),
                      deliveryServiceValues: _ctx.deliveryServiceValues,
                      "onUpdate:deliveryServiceValues": _cache[14] || (_cache[14] = ($event: any) => (_ctx.deliveryServiceValues = $event)),
                      error: _ctx.error,
                      cityOptions: _ctx.cityOptions,
                      clientOptions: _ctx.clientOptions,
                      deliveryServiceOptions: _ctx.deliveryServiceOptions,
                      onOpenList: _ctx.showClientListModal,
                      onFetchOrigins: _ctx.fetchOrigins,
                      onFetchClients: _ctx.fetchClients,
                      onDeleteOriginValue: _ctx.deleteOriginValue,
                      onDeleteDeliveryService: _ctx.deleteDeliveryService,
                      onResetFilter: _ctx.resetFilter,
                      isDisabled: _ctx.isDisabled,
                      filterValues: _ctx.filterValues
                    }, null, 8, ["originValue", "clientValue", "clientSearchValue", "clientLoading", "originLoading", "deliveryServiceValues", "error", "cityOptions", "clientOptions", "deliveryServiceOptions", "onOpenList", "onFetchOrigins", "onFetchClients", "onDeleteOriginValue", "onDeleteDeliveryService", "onResetFilter", "isDisabled", "filterValues"]),
                    (_ctx.clientsData.length)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "bg-white overflow-auto highlight-container",
                          onScrollend: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fetchNew && _ctx.fetchNew(...args)), ["prevent"]))
                        }, [
                          _createVNode("table", _hoisted_14, [
                            _createVNode("thead", null, [
                              _createVNode("tr", null, [
                                _createVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("bookingV3.filterClient.list.clientName")), 1),
                                _createVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("bookingV3.filterClient.list.clientAlias")), 1),
                                _createVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("bookingV3.filterClient.list.clientOrigin")), 1),
                                _createVNode("th", _hoisted_18, _toDisplayString(_ctx.$t("bookingV3.filterClient.list.clientType")), 1),
                                _createVNode("th", _hoisted_19, _toDisplayString(_ctx.$t("bookingV3.filterClient.list.clientServiceType")), 1),
                                _createVNode("th", _hoisted_20, _toDisplayString(_ctx.$t("bookingV3.filterClient.list.clientCode")), 1)
                              ])
                            ]),
                            _createVNode("tbody", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.clientsData, (client) => {
                                return (_openBlock(), _createBlock("tr", {
                                  key: client.clientCode,
                                  class: [
                      'cursor-pointer',
                      _ctx.selectedClientCode === client.clientCode
                        ? 'bg-gray-lp-200'
                        : ''
                    ],
                                  onMousedown: ($event: any) => (_ctx.onSelectClient(client))
                                }, [
                                  _createVNode("td", _hoisted_21, [
                                    _createVNode("label", _hoisted_22, [
                                      _createVNode("input", {
                                        type: "radio",
                                        name: "client",
                                        value: client.clientCode,
                                        class: "sr-only",
                                        onChange: ($event: any) => (_ctx.selectedClientCode = client.clientCode),
                                        onFocus: ($event: any) => (_ctx.onFocusRow($event, client)),
                                        onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.onSelectClient(client)), ["prevent"]), ["space"])
                                      }, null, 40, ["value", "onChange", "onFocus", "onKeydown"]),
                                      _createVNode("div", _hoisted_23, [
                                        _createVNode("span", null, _toDisplayString(client.clientName), 1),
                                        _createVNode("span", null, _toDisplayString(client.clientAlias), 1),
                                        _createVNode("span", null, _toDisplayString(client.clientOriginCity), 1),
                                        _createVNode("span", null, _toDisplayString(client.clientCategory), 1),
                                        _createVNode("span", null, _toDisplayString(client.clientPackageType), 1),
                                        _createVNode("span", null, _toDisplayString(client.clientCode), 1)
                                      ])
                                    ])
                                  ])
                                ], 42, ["onMousedown"]))
                              }), 128))
                            ])
                          ])
                        ], 32))
                      : _createCommentVNode("", true),
                    (_ctx.clientLoading)
                      ? (_openBlock(), _createBlock("div", _hoisted_24, [
                          (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (i) => {
                            return _createVNode(_component_Skeleton, {
                              key: i,
                              height: "32px"
                            })
                          }), 64))
                        ]))
                      : (!_ctx.clientsData.length && _ctx.isFiltered)
                        ? (_openBlock(), _createBlock("div", _hoisted_25, [
                            _hoisted_26,
                            _createVNode("div", _hoisted_27, [
                              _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("bookingV3.filterClient.notFound.title")), 1),
                              _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("bookingV3.filterClient.notFound.subTitle")), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["onEnter"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}